export var CustomerAccountAction;
(function (CustomerAccountAction) {
    CustomerAccountAction["SUSPEND"] = "suspend";
    CustomerAccountAction["RESUME"] = "resume";
})(CustomerAccountAction || (CustomerAccountAction = {}));
//# sourceMappingURL=customer-account-action.js.map